import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshegaonbusonrental() {



  const cardData =
  {
    keyword: 'Pune to Shegaon Bus on Rental',
    heading: 'Sanavi Travels: Daund to Shani Shingnapur Cab Service',
    headingDescription: 'Sanavi Travels offers reliable Pune to Shegaon Bus on Rental, providing safe, comfortable, and well-organized transportation for pilgrims, families, and groups traveling from Pune to the holy town of Shegaon. Our fleet of well-maintained AC and non-AC buses ensures spacious seating, smooth rides, and a peaceful long-distance travel experience. With experienced drivers, flexible one-way and round-trip bus rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free pilgrimage travel. We provide convenient pickup services across Pune including Hinjewadi, Baner, Wakad, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering key spiritual destinations such as Shri Gajanan Maharaj Temple, Anand Sagar, and nearby darshan spots. Choose Sanavi Travels for trusted Pune to Shegaon bus rental services, delivering comfort, safety, and a spiritually fulfilling travel experience.',

    top: 'Top Places to Visit in Shegaon with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shri Gajanan Maharaj Temple",
    "description": "Shri Gajanan Maharaj Temple is the main spiritual attraction of Shegaon, dedicated to Sant Gajanan Maharaj. Devotees from across India visit this sacred temple seeking peace, blessings, and spiritual upliftment. The temple is well-known for its cleanliness, discipline, and serene atmosphere."
  },
  {
    "title": "Samadhi Mandir",
    "description": "The Samadhi Mandir houses the sacred samadhi of Sant Gajanan Maharaj. It is a place of deep devotion where followers meditate and offer prayers. The calm surroundings create a powerful spiritual experience for devotees."
  },
  {
    "title": "Anand Sagar",
    "description": "Anand Sagar is a beautifully developed spiritual and recreational complex near the temple. It features lush gardens, fountains, sculptures, meditation zones, and children’s parks. The area blends devotion with relaxation, making it ideal for families."
  },
  {
    "title": "Dhyan Mandir",
    "description": "Dhyan Mandir is a meditation hall designed for silence and inner reflection. Devotees come here to meditate in a peaceful environment, away from noise and crowds, enhancing spiritual focus and mindfulness."
  },
  {
    "title": "Bhakt Niwas",
    "description": "Bhakt Niwas provides clean and affordable accommodation for devotees visiting Shegaon. Managed by the temple trust, it ensures a comfortable stay with well-maintained facilities and spiritual surroundings."
  },
  {
    "title": "Prasad Bhojanalaya",
    "description": "The Prasad Bhojanalaya serves free and hygienic meals to devotees, reflecting the values of service and equality taught by Sant Gajanan Maharaj. The simple yet nourishing food adds to the spiritual experience."
  },
  {
    "title": "Shegaon Railway Station Area",
    "description": "The area around Shegaon Railway Station is well-developed with shops, eateries, and transport facilities. It ensures smooth connectivity for pilgrims arriving from different parts of India."
  },
  {
    "title": "Sant Gajanan Maharaj Garden",
    "description": "This well-maintained garden near the temple complex offers a peaceful space for walking and relaxation. Devotees often spend quiet moments here after darshan, enjoying the greenery and calm ambiance."
  },
  {
    "title": "Temple Trust Facilities",
    "description": "The Shri Gajanan Maharaj Sansthan Trust manages hospitals, schools, and charitable services in Shegaon. These facilities reflect the saint’s teachings of selfless service and social welfare."
  },
  {
    "title": "Local Devotional Markets",
    "description": "Markets around the temple sell devotional items, books, prasad, and souvenirs related to Sant Gajanan Maharaj. These markets add cultural vibrancy and allow devotees to take home spiritual memories."
  }
]
,



"services": [
  {
    "name": "Pune to Shegaon Bus on Rental",
    "description": "Pune to Shegaon Bus on Rental provides a comfortable and well-organized travel solution for devotees and travelers visiting Shegaon for Gajanan Maharaj darshan. Spacious, well-maintained buses with clean interiors and comfortable seating ensure a relaxed journey over long distances. Experienced chauffeurs handle highway driving, traffic conditions, and route planning efficiently to ensure timely departures and safe arrivals. Ideal for families, religious groups, and senior citizens, this service supports flexible travel schedules, temple visit planning, and smooth end-to-end pilgrimage travel."
  },
  {
    "name": "Shegaon Bus Hire from Pune",
    "description": "Shegaon Bus Hire from Pune offers reliable and convenient bus rental services tailored for religious tours and group travel. Comfortable buses with professional drivers ensure safe and punctual travel for devotees heading to Shegaon. Suitable for families, community groups, and tour organizers, this service focuses on smooth coordination, comfort, and a peaceful travel experience for temple visits."
  },
  {
    "name": "AC Bus Pune to Shegaon",
    "description": "AC Bus Pune to Shegaon ensures a cool and comfortable journey, especially during long-distance travel and warm weather. Fully air-conditioned buses with comfortable seating, good ventilation, and smooth suspension reduce travel fatigue. Skilled chauffeurs ensure safe driving and efficient route management, making this option ideal for devotees, families, and organized religious groups."
  },
  {
    "name": "Gajanan Maharaj Darshan Bus",
    "description": "Gajanan Maharaj Darshan Bus is specially designed for devotees planning darshan at the Shegaon temple. The service focuses on timely departures, convenient temple-area drop-offs, and comfortable return journeys. Well-maintained buses with experienced drivers help pilgrims manage darshan schedules smoothly while enjoying a calm and devotional travel experience."
  },
  {
    "name": "Religious Bus Tour Pune",
    "description": "Religious Bus Tour Pune offers organized bus travel for various pilgrimage destinations, including Shegaon. Comfortable buses with professional chauffeurs ensure safe and peaceful journeys for religious groups and families. This service supports planned itineraries, group coordination, and a respectful travel environment suitable for devotional tours."
  },
  {
    "name": "Family Shegaon Bus Trip",
    "description": "Family Shegaon Bus Trip is designed to make family travel safe, comfortable, and convenient. Spacious buses with comfortable seating and ample luggage space accommodate families of all sizes. Professional drivers ensure smooth driving and flexible schedules, making it ideal for family pilgrimages from Pune to Shegaon."
  },
  {
    "name": "Group Travel Shegaon Bus",
    "description": "Group Travel Shegaon Bus provides efficient transportation solutions for large groups, religious organizations, and community tours. Well-maintained buses with experienced chauffeurs ensure coordinated travel, punctual arrivals, and comfortable seating for all passengers. This service is ideal for group darshan trips and organized pilgrimages."
  },
  {
    "name": "Affordable Shegaon Bus Hire",
    "description": "Affordable Shegaon Bus Hire offers budget-friendly bus rental options without compromising on comfort or safety. Clean buses with trained drivers ensure a smooth journey at economical pricing. Suitable for families, religious groups, and cost-conscious travelers, this service balances affordability, reliability, and convenience."
  },
  {
    "name": "Chauffeur Driven Bus Shegaon",
    "description": "Chauffeur Driven Bus Shegaon provides a stress-free travel experience with professional drivers managing navigation, traffic, and timing. Comfortable buses allow passengers to relax, pray, and enjoy the journey. Especially suitable for elderly devotees and large groups, this service emphasizes safety, punctuality, and courteous service."
  },
  {
    "name": "Best Shegaon Bus Service Pune",
    "description": "Best Shegaon Bus Service Pune delivers high-quality and dependable bus rental services with well-maintained vehicles and trained chauffeurs. Comfortable seating, clean interiors, and reliable scheduling ensure a pleasant travel experience. Ideal for families, tourists, and regular pilgrims, this service focuses on comfort, reliability, and customer satisfaction."
  },
  {
    "name": "Pune Shegaon Travel Bus",
    "description": "Pune Shegaon Travel Bus offers dedicated bus services for devotees and tourists traveling between Pune and Shegaon. Spacious buses with professional drivers ensure smooth long-distance travel, timely arrivals, and a relaxed journey. This service is suitable for temple visits, group tours, and organized pilgrimage plans."
  },
  {
    "name": "Temple Tour Bus Pune",
    "description": "Temple Tour Bus Pune provides organized transportation for temple tours and religious sightseeing. Comfortable buses with experienced chauffeurs support visits to Shegaon and other holy destinations. Ideal for families, groups, and senior citizens, this service ensures a peaceful, well-planned, and devotional travel experience."
  },
  {
    "name": "Pilgrimage Bus Hire Pune",
    "description": "Pilgrimage Bus Hire Pune offers reliable bus rental solutions for religious travel and spiritual tours. Well-maintained buses, professional drivers, and flexible itineraries ensure safe and comfortable journeys for pilgrims. This service is ideal for community groups, families, and organized religious travel from Pune."
  },
  {
    "name": "Tourist Bus Shegaon",
    "description": "Tourist Bus Shegaon provides comfortable bus services for tourists and pilgrims visiting Shegaon and nearby attractions. Clean buses with comfortable seating and knowledgeable drivers ensure a pleasant travel experience. Suitable for families, groups, and leisure travelers combining tourism with religious visits."
  },
  {
    "name": "Online Bus Booking Pune",
    "description": "Online Bus Booking Pune allows customers to easily reserve buses for Pune to Shegaon travel through a convenient booking process. Users can select bus type, travel date, group size, and trip preferences with quick confirmation. Reliable buses with professional chauffeurs ensure safe, organized, and hassle-free pilgrimage travel."
  }
],
"tableData": [
  ["Pune to Shegaon Bus on Rental", "Shegaon Bus Hire from Pune"],
  ["AC Bus Pune to Shegaon", "Gajanan Maharaj Darshan Bus"],
  ["Religious Bus Tour Pune", "Family Shegaon Bus Trip"],
  ["Group Travel Shegaon Bus", "Affordable Shegaon Bus Hire"],
  ["Chauffeur Driven Bus Shegaon", "Best Shegaon Bus Service Pune"],
  ["Pune Shegaon Travel Bus", "Temple Tour Bus Pune"],
  ["Pilgrimage Bus Hire Pune", "Tourist Bus Shegaon"],
  ["Online Bus Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Shegaon Bus on Rental with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable bus rental services from Pune to Shegaon, ideal for pilgrimages, group tours, family trips, and spiritual journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and regularly serviced buses to ensure a smooth and enjoyable journey from Pune to Shegaon."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Pune to Shegaon route, ensuring safe and timely travel throughout your trip."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront and clear pricing for Pune to Shegaon bus rentals, inclusive of fuel, tolls, and driver allowances without hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist you with bookings, itinerary planning, and travel queries during your Pune to Shegaon journey."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus rental packages based on your Pune to Shegaon travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience for passengers."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Shegaon bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Shegaon bus rentals?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable Pune to Shegaon bus rental services for religious journeys, group tours, and family trips.'
  },
  {
    question: 'How can I book a Pune to Shegaon bus rental?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are used for the Pune to Shegaon route?',
    answer: 'Sanavi Travels provides air-conditioned and well-maintained buses suitable for long-distance travel from Pune to Shegaon.'
  },
  {
    question: 'Are the drivers experienced on the Pune to Shegaon route?',
    answer: 'Yes, our professional drivers are licensed, courteous, and familiar with the Pune to Shegaon journey.'
  },
  {
    question: 'Can I customize my Pune to Shegaon travel itinerary?',
    answer: 'Absolutely. You can customize routes, stops, and the duration of your Pune to Shegaon bus trip as per your convenience.'
  },
  {
    question: 'Is the bus rental service available 24x7?',
    answer: 'Yes, Sanavi Travels offers support and assistance throughout your Pune to Shegaon bus journey.'
  },
  {
    question: 'Are the buses sanitized before departure?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety.'
  },
  {
    question: 'What payment options are available for Pune to Shegaon bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Shegaon bus rental trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vijay Patil',
    feedback: 'Booked a Pune to Shegaon bus rental with Sanavi Travels. Comfortable journey, excellent bus, and reliable service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Kulkarni',
    feedback: 'Had a great experience traveling from Pune to Shegaon. The bus was clean and the driver was very professional.',
    rating: 5
  }
];











































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shegaon Bus on Rental - Sanavi Travels",
  "description": "Book AC and chauffeur-driven buses from Pune to Shegaon with Sanavi Travels. Ideal for Gajanan Maharaj darshan, religious tours, family trips, group travel, pilgrimage tours, and comfortable tourist journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};



  return (
    <div>
<Helmet>
  <title>
    Pune to Shegaon Bus on Rental | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and chauffeur-driven buses from Pune to Shegaon with Sanavi Travels. Perfect for Gajanan Maharaj darshan, religious tours, family trips, group travel, pilgrimage tours, and safe tourist journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/88.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshegaonbusonrental;